import { $ } from "@/common/Axios";

export default {
  /**
   * 心理测试
   */
  paper_upload: {
    /*
     * 导入习题
     * id ID (integer query required)
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/bms/mentalTest/paper/upload", p, c),
  },
  paper_save: {
    /*
     * 添加编辑
     * paper  ( query required)
     */
    post: (p, c) => $.post("/api/bms/mentalTest/paper/save", p, c),
  },
  paper_saveExercise: {
    /*
     * 添加编辑习题
     * exercise  ( query required)
     */
    post: (p, c) => $.post("/api/bms/mentalTest/paper/saveExercise", p, c),
  },
  paper_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/mentalTest/paper/list", p, c),
  },
  paper_listSimplePaper: {
    /*
     * 简单试卷列表
     */
    get: (p, c) => $.get("/api/bms/mentalTest/paper/listSimplePaper", p, c),
  },
  paper_listPaperString: {
    /*
     * 简单试卷列表
     */
    get: (p, c) => $.get("/api/bms/mentalTest/paper/listPaperString", p, c),
  },
  paper_listPaperForClient: {
    /*
     * C端试卷列表
     */
    get: (p, c) => $.get("/api/bms/mentalTest/paper/listPaperForClient", p, c),
  },
  paper_listExercise: {
    /*
     * 根据试卷id查询习题列表
     * id paperId (integer query required)
     * ableStatus 启用禁用 (string query )
     */
    get: (p, c) => $.get("/api/bms/mentalTest/paper/listExercise", p, c),
  },
  paper_downloadMould: {
    /*
     * 下载习题导入模版
     */
    get: (p, c) => $.get("/api/bms/mentalTest/paper/downloadMould", p, c),
  },
  paper_remove: {
    /*
     * 删除
     * id ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/mentalTest/paper/remove", p, c),
  },
  paper_removeExercise: {
    /*
     * 删除
     * id 习题列表的ID (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/mentalTest/paper/removeExercise", p, c),
  },

  /**
   * 心理测试员工
   */
  employee_answer: {
    /*
     * 交卷
     * applyName 姓名 (string query required)
     * applyPosition 应聘岗位 (string query required)
     * paperId 试卷ID (integer query required)
     * answerText JSON（id，answer） (string query required)
     */
    post: (p, c) => $.post("/api/bms/mentalTest/employee/answer", p, c),
  },
  employee_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/mentalTest/employee/list", p, c),
  },
  employee_getPaperDetail: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/mentalTest/employee/getPaperDetail", p, c),
  },
};
